import {baseDataService} from "@/services/baseData.service";

export const state = {
    customers:[],
    saleReps:[],
    contactTypes:[]
}
export const getters = {
    getCustomer: (state) => (id) => {
        // console.log("Looking for ",id,state.all.length)
        return state.customers.find((customer) => customer.idCustomerMaster == id);
    },
};
export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    async getSalesReps({state,commit}){
        try { 
            if(state.saleReps && state.saleReps.length==0){
                let prod = await baseDataService.listSalesReps(); 
                commit('setSalesReps', prod);
                return prod;
            }
            return state.saleReps;
        } catch (error) {
            console.error("List categories",error);
        }
        return state.saleReps
    },
    async listDBLast({state,commit}) {         

        try { 
            if(state.customers && state.customers.length==0){
                let prod = await baseDataService.listSalesRepCustomers(); 
                commit('setCustomers', prod);
                return prod;
            }
            return state.customers;
        } catch (error) {
            console.error("List categories",error)
            commit('load_storage');
        }
        return state.customers
    },
    async getCustomer({state,commit},customerID){
        let p = localStorage.getItem("ar_" + customerID);
        if(p && p.idCustomerMaster){
            return p;
        }
        if(state.customers && state.customers.length==0){
            let custlist = await actions.listDBLast({state,commit});
            return custlist.find((customer) => customer.idCustomerMaster == customerID);
        }
        return state.customers.find((customer) => customer.idCustomerMaster == customerID);
    },
    async getContactTypes({state,commit}){
        try { 
            if(state.contactTypes && state.contactTypes.length==0){
                let prod = await baseDataService.listContactHeaders(); 
                commit('setContactHeaders', prod);
                return prod;  
            }
            return state.contactTypes; 
        } catch (error) {
            console.error("List Contact Types",error);
        }
        let ch = JSON.parse(localStorage.getItem("contactTypes"));
        if(ch.length>0){
            return ch;
        }
        return state.contactTypes;
    }
}
export const mutations = {
    setCustomers(state, customers) {
        state.customers = customers;
        let allProductKeys = customers.map(x=>x.idCustomerMaster);
        localStorage.setItem("idCustomerMaster",JSON.stringify(allProductKeys));
        customers.forEach(x => {
            localStorage.setItem("ar_" + x.idCustomerMaster,JSON.stringify(x));
        });    
    },
    setSalesReps(state, saleReps) {
        state.saleReps = saleReps;
    },
    load_storage(state){
        let allProductsId = JSON.parse(localStorage.getItem("idCustomerMaster"));
        if(allProductsId && allProductsId.length){
            let allProducts = [];
            allProductsId.forEach(c=>{
                let p = JSON.parse(localStorage.getItem("ar_" + c));
                if(p && p.idCustomerMaster){
                    allProducts.push(p);
                }
            });
            state.customers = allProducts;
        } 
    },
    setContactHeaders(state, contactTypes){
        localStorage.setItem("contactTypes",JSON.stringify(contactTypes));
        state.contactTypes = contactTypes;
    },
    clearData(state){
        state.customers=[];
        state.saleReps=[];
        state.contactTypes=[]; 
    }


}
